import { SearchUrlParamBuilder } from '@/core/utils'
import axios from 'axios'
const URL_PATH = 'api/itemAta/alteracaoClassificacao'
class AlterarClassificacaoApiClient {
	async alterarClassificacao(dados) {
		let URL = new SearchUrlParamBuilder({
			urlPath: `${URL_PATH}/alterarClassificacaoFornecedorItemAta`,
		}).build()
		return await axios.put(URL, dados)
	}

	async buscarHistoricoFornecedoresPorIdItemAtaPaginado(paginacao, idItemAta) {
		const url = new SearchUrlParamBuilder({
			urlPath: `${URL_PATH}/historico`,
			filters: { idItemAta: idItemAta },
			pagingAndSorting: paginacao,
		}).build()

		return await axios.get(url)
	}
}

export default new AlterarClassificacaoApiClient()
